/* Native details remain usable without JavaScript. */
class KslFaq extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.states = new Map();
    this.preference = matchMedia('(prefers-reduced-motion: reduce)');
    const signal = this.controller.signal;
    this.querySelectorAll('.ksl-faq__item').forEach(item => {
      const summary = item.querySelector('summary');
      const answer = item.querySelector('.ksl-faq__answer');
      if (!summary || !answer) return;
      const state = { item, summary, answer, target: item.open };
      this.states.set(item, state);
      summary.addEventListener('click', event => {
        if (this.preference.matches || !document.body.hasAttribute('data-ksl-motion') || !item.animate) return;
        event.preventDefault();
        this.toggle(state, !state.animation ? !item.open : !state.target);
      }, { signal });
    });
    this.preference.addEventListener('change', () => this.settleAll(), { signal });
    window.addEventListener('resize', () => this.settleAll(), { signal });
  }

  toggle(state, target) {
    const { item, summary, answer } = state;
    const from = item.getBoundingClientRect().height;
    const opacity = getComputedStyle(answer).opacity;
    const transform = getComputedStyle(answer).transform;
    this.cancel(state);
    state.target = target;
    item.open = false;
    const closed = item.getBoundingClientRect().height;
    item.open = true;
    const expanded = item.getBoundingClientRect().height;
    item.dataset.kslExpanded = String(target);
    summary.setAttribute('aria-expanded', String(target));
    answer.inert = !target;
    item.style.overflow = 'clip';
    state.animation = item.animate([{ height: `${from}px` }, { height: `${target ? expanded : closed}px` }], {
      duration: 300, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both',
    });
    state.answerAnimation = answer.animate([
      { opacity: from <= closed + 1 ? 0 : opacity, transform: from <= closed + 1 ? 'translateY(4px)' : transform },
      { opacity: target ? 1 : 0, transform: target ? 'translateY(0)' : 'translateY(4px)' },
    ], { duration: 240, easing: 'ease-out', fill: 'both' });
    state.animation.onfinish = () => this.settle(state);
  }

  cancel(state) {
    if (state.animation) state.animation.onfinish = null;
    state.animation?.cancel();
    state.answerAnimation?.cancel();
    state.animation = state.answerAnimation = null;
  }

  settle(state) {
    this.cancel(state);
    state.item.open = state.target;
    state.item.style.removeProperty('overflow');
    delete state.item.dataset.kslExpanded;
    state.summary.removeAttribute('aria-expanded');
    state.answer.inert = false;
  }

  settleAll() {
    this.states?.forEach(state => { if (state.animation) this.settle(state); });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.settleAll();
  }
}
if (!customElements.get('ksl-faq')) customElements.define('ksl-faq', KslFaq);
